// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/copy-trading-img/copy_trandingbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/copy-trading-img/copytrading_herobgslider.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/copy-trading-img/exceedsbg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copy Trading Page CSS */
.copy_trading_page_wrapper {
    background-color: #000000;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-position: bottom center;
    background-repeat: no-repeat;
    color: #ffffff;
    min-height: 540px;
    border-radius: 0px 0px 24px 24px;
    padding: 0 0 60px 0;
    /* font-family: "Inter", sans-serif; */
    position: relative;
    overflow: hidden;
}


.tabs_right {
    margin-top: -11px;
}

.hero_grid_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
    background-size: 100px 50px;
    z-index: 0;
    transform: perspective(1000px) rotateX(75deg) translateY(-20%) scale(2);
    transform-origin: top center;
    opacity: 0.8;
    pointer-events: none;
}

.copy_trading_page_wrapper .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0px 20px;
    position: relative;
    z-index: 1;
}

/* Tabs */
.copy_trading_top_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 0px;
}

.copy_trading_top_bar {
    width: 100%;
    display: block;
    border-bottom: 1px solid #ffffff20;
    margin-bottom: 32px;
}

.tabs_left {
    display: flex;
    gap: 20px;
}

.tab_btn {
    background: none;
    border: none;
    color: #848e9c;
    font-size: 14px;
    cursor: pointer;
    padding-bottom: 10px;
    position: relative;
}

.tab_btn.active {
    color: #ffffff;
    font-weight: 600;
}

.tab_btn.active::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 35%;
    height: 2px;
    background-color: #ffffff;
    margin: 0 auto;
    right: 0px;
}

.tabs_right .help_btn {
    background: none;
    border: none;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
}

.help_btn:hover {
    color: #ffffff;
}

/* Hero Section */
.copy_trading_hero {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 40px;
}

.hero_left {
    flex: 1 1;
    max-width: 320px;
    margin-top: 32px;
}

.copy_trading_top_bar .container {
    max-width: 1440px;
}


.copy_trading_page_wrapper .hero_title {
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 30px;
}

.hero_desc {
    width: 65%;
    font-size: 20px;
    color: #ffffff;
    line-height: 1.5;
    margin: 40px 0px 15px;
}

.hero_stats {
    display: flex;
    gap: 40px;
}

.stat_item h3 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 5px;
}

.stat_item p {
    font-size: 14px;
    color: #E3E3E3;
    margin: 0;
}

/* Slider Card */
.hero_right {
    flex: 1 1;
    max-width: 792px;
}

.hero_slider_card {
    background: #000000;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-position: bottom center;
    background-repeat: no-repeat;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-height: 275px;
}

.slider_content {
    flex: 1 1;
}

.slide_tag {
    color: #fff;
    font-size: 18px;
    margin-bottom: 15px;
    display: inline-block;
    position: relative;
}

.slide_tag::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 24px;
    height: 2px;
    background-color: #cca450;
}

.slide_title {
    max-width: 80%;
    font-size: 28px;
    font-weight: 500;
    margin: 24px 0px;
    /* margin-top: 25px; */
    line-height: 1.3;
}

.slide_subtitle {
    font-size: 26px;
    font-weight: 500;
    margin-bottom: 30px;
    line-height: 1.3;
    margin-top: 0;
}

.slide_link {
    background: none;
    border: none;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    font-weight: 500;
}

.slide_link:hover {
    color: #cca450;
}

.slider_image {
    display: flex;
    align-items: center;
    justify-content: center;
}

.slider_image img {
    max-width: 190px;
    height: auto;
}

.slider_pagination {
    position: absolute;
    bottom: 25px;
    right: 40px;
    display: flex;
    gap: 6px;
}

.slider_pagination .dot {
    width: 6px;
    height: 6px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
}

.slider_pagination .dot.active {
    width: 20px;
    border-radius: 4px;
    background: #ffffff;
}

@media (max-width: 768px) {
    .copy_trading_hero {
        flex-direction: column;
    }

    .hero_right {
        width: 100%;
        max-width: 100%;
    }
}

/* --- Traders Section Below Hero --- */
.traders_section_wrapper {
    background-color: #000;
    color: #1e2329;
    padding: 60px 0;
    font-family: "Inter", sans-serif;
}

body.light_theme .traders_section_wrapper {
    background-color: #ffffff;
}

.traders_section_wrapper .container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 20px;
}

/* New Traders */
.new_traders_section {
    margin-bottom: 60px;
}

.section_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.section_header h2 {
    font-size: 22px;
    font-weight: 700;
    color: #ececec;
    margin: 0;
}

body.light_theme .section_header h2 {
    color: #1e2329;
}

.header_actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.icon_btn {
    background: none;
    cursor: pointer;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
}


.icon_btn img {
    width: 20px;
}

.search_bar {
    display: flex;
    align-items: center;
    background: #ffffff08;
    border: 1px solid #c8c8c840;
    border-radius: 12px;
    padding: 8px 12px;
    width: 250px;
}

body.light_theme .search_bar {
    background: #ffffff;
    border: 1px solid #c8c8c8;
}

.search_bar i {
    font-size: 16px;
    color: #dbdbdb;
}

body.light_theme .search_bar i {
    color: #000000;
}

.search_bar input {
    border: none;
    outline: none;
    background: transparent;
    margin-left: 8px;
    font-size: 14px;
    color: #dbdbdb;
    width: 100%;
}

body.light_theme .search_bar input {
    color: #1e2329;
}

.new_traders_list {
    display: flex;
    gap: 20px;
    align-items: center;
    overflow-x: auto;
    scroll-behavior: smooth;
    padding-bottom: 10px;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.new_traders_list::-webkit-scrollbar {
    display: none;
}

.new_trader_card {
    flex: 0 0 auto;
    min-width: 280px;
    display: flex;
    min-height: 82px;
    align-items: center;
    background: #ffffff0a;
    border: 1px solid #eaecef21;
    color: #fff;
    border-radius: 12px;
    padding: 16px;
    gap: 12px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    position: relative;
}

body.light_theme .new_trader_card {
    color: #ffffff96;
    background: #ffffff;
    border: 1px solid #eaecef;
}

.nt_avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
}

.nt_info h4 {
    font-size: 12px;
    font-weight: 500;
    color: #e5e5e5;
    margin: 0 0 4px 0;
}

body.light_theme .nt_info h4 {
    color: #000;
}

.nt_info p {
    font-size: 14px;
    color: #848e9c;
    font-weight: 500;
    margin: 0;
}

.nt_info p strong {
    color: #1e2329;
}

.green_text {
    color: #00B47D;
    margin-left: 6px;
}

.arrow_right {
    position: absolute;
    right: 16px;
    color: #848e9c;
    font-size: 18px;
}

.next_btn {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    padding: 0px;
    height: 40px;
    border-radius: 50%;
    background: #ffffff;
    color: #1e2329;
    border: 1px solid #eaecef;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    z-index: 2;
}

.prev_btn {
    position: absolute;
    left: -20px;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    padding: 0px;
    border-radius: 50%;
    background: #ffffff;
    color: #1e2329;
    border: 1px solid #eaecef;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    z-index: 2;
}

/* Recommend Section */
.recommend_tabs {
    display: flex;
    gap: 32px;
    margin-bottom: 24px;
}

.rt_tab {
    background: none;
    border: none;
    font-size: 22px;
    font-weight: 700;
    color: #848e9c;
    cursor: pointer;
    padding-bottom: 16px;
    position: relative;
}

.rt_tab.active {
    color: #fff;
}

body.light_theme .rt_tab.active {
    color: #1e2329;
}

body.light_theme .rt_tab.active::after {
    background: #1e2329;
}

.rt_tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    right: 0px;
    left: 0;
    margin: 0 auto;
    width: 32px;
    height: 3px;
    background: #fbfbfb;
    border-radius: 2px;
}

/* Grid */
.traders_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

.trader_grid_card {
    background: #ffffff0a;
    border: 1px solid #eaecef21;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.02);
}


body.light_theme .trader_grid_card {
    background: #ffffff;
    border: 1px solid #eaecef;
}

.tgc_header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
}

.tgc_user {
    display: flex;
    gap: 12px;
    align-items: center;
}

.tgc_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fefefe;
    color: #1e2329;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    border: 1px solid #eaecef;
}

.tgc_avatar_img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
}

.tgc_name_info h4 {
    font-size: 16px;
    font-weight: 400;
    margin: 0 0 4px 0;
    color: #fffffff7;
    display: flex;
    align-items: center;
    gap: 8px;
}

body.light_theme .tgc_name_info h4 {
    color: #000000;
}

.tgc_label {
    font-size: 10px;
    background: #f0f0ff;
    color: #7b61ff;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 500;
}

.tgc_name_info p {
    font-size: 12px;
    color: #848e9c;
    margin: 0;
}

.copy_btn {
    background: #1D1D1D;
    color: #ffffff;
    border: none;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.tgc_chart_section {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 12px;
    padding-bottom: 12px;
}

.tgc_pnl {
    flex: 1 1;
}

.pnl_label {
    font-size: 13px;
    color: #848e9c;
    margin: 0 0 4px 0;
}

.tgc_pnl h3 {
    font-size: 24px;
    margin: 0 0 4px 0;
}

.usdt_text {
    font-size: 12px;
    color: #86898d;
    margin: 0;
    font-weight: 500;
}

body.light_theme .usdt_text {
    color: #1e2329;
}

.tgc_chart {
    max-width: 130px;
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
}

.tgc_chart img {
    height: 40px;
    object-fit: contain;
}

.tgc_stats {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.tgc_stat_row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
}

.tgc_stat_row span {
    color: #848e9c;
}

.tgc_stat_row strong {
    color: #cbcbcb;
    font-weight: 500;
}

body.light_theme .tgc_stat_row strong {
    color: #1e2329;
}

/* Pagination */
.pagination_wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 32px;
}

.page_btn {
    background: #080808;
    border: 1px solid #eaecef1a;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

body.light_theme .page_btn {
    background: #ffffff;
    border: 1px solid #eaecef;
    color: #1e2329;

}

.page_btn:hover {
    background: #f5f5f5;
}

.page_btn.active {
    border-color: #1e2329;
    font-weight: 600;
}

.page_dots {
    color: #848e9c;
    padding: 0 4px;
}

/* Rising Talents Section */
.rising_talents_section {
    margin-top: 20px;
    padding-top: 40px;
}

.rt_header_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
}

.rt_header_left h2 {
    font-size: 30px;
    font-weight: 700;
    color: #f5f5f5;
    margin: 0 0 8px 0;
}

body.light_theme .rt_header_left h2 {
    color: #1e2329;
}

.rt_header_left p {
    font-size: 16px;
    padding-top: 5px;
    color: #848e9c;
    margin: 0;
}

.more_btn {
    background: #ffffff12;
    border: 1px solid #eaecef26;
    border-radius: 20px;
    padding: 6px 16px;
    font-size: 14px;
    color: #1e2329;
    cursor: pointer;
    font-weight: 500;
}

body.light_theme .more_btn {
    background: #ffffff;
    border: 1px solid #eaecef;
}

/* .more_btn:hover {
    background: #f5f5f5;
} */

.rising_talents_list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
}

.rt_card {
    background: #0808080d;
    border: 1px solid #e9eaeb0f;
    border-radius: 16px;
    padding: 24px;
    min-height: 106px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

body.light_theme .rt_card {
    background: #080808;
    border: 1px solid #e9eaeb17;
}

body.light_theme .rt_card {
    background: #ffffff;
    border: 1px solid #e9eaeb;
}

body .market-table-container {
    background-color: transparent;
}

.rt_user {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
}

.rt_avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
}

body.light_theme .rt_user_info h4 {
    color: #000;
}

.rt_user_info h4 {
    font-size: 18px;
    color: #fff;
    font-weight: 700;
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    gap: 6px;
}

.medal_icon {
    width: 20px;
    height: 20px;
    margin-left: 10px;
}

.rt_user_info p {
    font-size: 12px;
    color: #848e9c;
    margin: 0;
}

.rt_roi {
    flex: 1 1;
    text-align: left;
    padding-left: 20px;
}

.rt_roi .roi_label {
    font-size: 12px;
    color: #848e9c;
    margin: 0 0 4px 0;
}

.rt_roi .green_text {
    font-size: 20px;
    margin: 0;
    font-weight: 700;
}

.rt_card .copy_btn {
    background: #2a2e39;
    color: #ffffff;
    padding: 10px 24px;
    border-radius: 20px;
    font-weight: 500;
}

/* Prudent Trader Section */
.prudent_trader_section {
    margin-top: 30px;
    padding-top: 40px;
}

.prudent_trader_list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
}

.lock_btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #3c404a !important;
}

.lock_icon {
    width: 12px;
    height: 12px;
}

/* Total Profit Sharing Section */
.total_profit_section {
    margin-top: 60px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-position: center;
    border-radius: 16px;
    padding: 60px 0;
    text-align: center;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.profit_subtitle {
    font-size: 20px;
    margin: 0 0 16px 0;
    color: #e6e8eb;
}

.profit_title {
    font-size: 56px;
    font-weight: 700;
    color: #dfb065;
    margin: 0 0 40px 0;
}

.profit_actions {
    display: flex;
    gap: 16px;
}

.btn_apply {
    background: #dfb065;
    color: #1e2329;
    border: none;
    border-radius: 24px;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
}

.profit_actions {
    display: flex;
    gap: 16px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50px;
    padding: 12px;
    gap: 8px;
}

.btn_go {
    background: none;
    color: #ffffff;
    border: none;
    border-radius: 24px;
    padding: 0px 10px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
}


/* CFD Filter Bar Styles */
.cfd_filter_bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.cfd_filter_left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.cfd_filter_btn {
    background: none;
    border: none;
    font-size: 14px;
    font-weight: 500;
    color: #848e9c;
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.cfd_filter_btn:hover {
    color: #1e2329;
    background-color: #f5f5f5;
}

.cfd_filter_btn.active {
    background: #f5f5f5;
    color: #1e2329;
    font-weight: 600;
}

.cfd_filter_right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.copy_filter_btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    border: 1px solid #eaecef;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #1e2329;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 38px;
    box-sizing: border-box;
}

.copy_filter_btn:hover {
    background-color: #f5f5f5;
}

.copy_filter_btn i {
    font-size: 16px;
}

.copy_search_wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 8px;
    padding: 8px 12px;
    width: 200px;
    height: 38px;
    box-sizing: border-box;
    transition: all 0.2s ease;
}

.copy_search_wrapper:focus-within {
    background: #ffffff;
    box-shadow: 0 0 0 1px #1e2329;
}

.copy_search_icon {
    color: #848e9c;
    margin-right: 8px;
    font-size: 16px;
}

.copy_search_input {
    background: transparent;
    border: none;
    outline: none;
    width: 100%;
    font-size: 14px;
    color: #1e2329;
}

.copy_search_input::placeholder {
    color: #848e9c;
}

.cfd_dropdown {
    position: relative;
}

.cfd_dropdown_btn {
    background: #ffffff;
    color: #1e2329;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 140px;
    transition: all 0.2s ease;
}

.cfd_dropdown_btn:hover {
    background: #f8f9fa;
}

.cfd_dropdown_menu {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.06);
    z-index: 100;
    min-width: 140px;
    padding: 8px 0;
    overflow: hidden;
}

.cfd_dropdown_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 16px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: #1e2329;
    font-weight: 500;
    transition: all 0.2s ease;
}

.cfd_dropdown_item:hover {
    background: #f8f9fa;
}

.cfd_check_circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #000000;
    color: #ffffff;
    font-size: 8px;
}


/* Copy Settings Detail Page Styles */
.copy_settings_wrapper {
    background-color: #000000;
    color: #ffffff;
    padding: 40px 0 80px;
    font-family: "Inter", sans-serif;
}

body.light_theme .copy_settings_wrapper {
    background-color: #ffffff;
    color: #1e2329;
}

.copy_settings_wrapper .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.breadcrumbs {
    font-size: 14px;
    color: #848e9c;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.breadcrumbs span:first-child {
    cursor: pointer;
    transition: color 0.2s;
}

.breadcrumbs span:first-child:hover {
    color: #1e2329;
}

.copy_settings_title {
    font-size: 32px;
    font-weight: 600;
    margin: 70px 0px 30px;
}

.copy_settings_layout {
    display: flex;
    gap: 40px;
    align-items: flex-start;
}

.copy_settings_left {
    flex: 1 1;
    max-width: 720px;
    display: flex;
    flex-direction: column;
    gap: 28px;
}

.copy_settings_right {
    width: 380px;
    position: sticky;
    top: 20px;
}

/* Form Group */
.form_group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.form_label {
    font-size: 16px;
    font-weight: 500;
    color: #a6a6a6;
    letter-spacing: -0.40px;
}

body.light_theme .form_label {
    color: #1e2329;
}

.input_box_wrapper {
    background: #171a20;
    border-radius: 8px;
    padding: 14px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

body.light_theme .input_box_wrapper {
    background: #F7F7F7;
}

.input_box_wrapper input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 16px;
    color: #9b9b9b;
    width: 70%;
}

.input_box_wrapper input::placeholder {
    color: #9b9b9b;
}

.input_suffix {
    font-size: 14px;
    color: #848e9c;
    font-weight: 500;
}

.input_suffix_max {
    color: #BE995B;
    font-weight: 500;
    cursor: pointer;
    margin-left: 2px;
}

/* Slider Style */
.slider_container {
    position: relative;
    height: 24px;
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 8px;
}

.slider_track_wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 4px;
    background: #171a20;
    border-radius: 2px;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 1;
}

body.light_theme .slider_track_wrapper {
    background: #eaecef;
}

.slider_dots {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    pointer-events: none;
    z-index: 2;
}

.slider_dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #eaecef;
    border: 2px solid #ffffff;
    box-shadow: 0 0 0 1px #eaecef;
    transition: all 0.2s ease;
}

.slider_dot.active {
    background: #c8cbd2;
    box-shadow: 0 0 0 1px #c8cbd2;
}

.slider_bar_input {
    appearance: none;
    width: 100%;
    height: 4px;
    background: transparent;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    outline: none;
    margin: 0;
    cursor: pointer;
}

/* Chrome, Safari, Edge, Opera */
.slider_bar_input::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #c8cbd2;
    border: 2px solid #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    margin-top: -4px;
    -webkit-transition: background-color 0.15s;
    transition: background-color 0.15s;
}

.slider_bar_input::-webkit-slider-thumb:hover {
    background: #1e2329;
}

.slider_bar_input::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    background: transparent;
    border: none;
}

/* Firefox */
.slider_bar_input::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #c8cbd2;
    border: 2px solid #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    -moz-transition: background-color 0.15s;
    transition: background-color 0.15s;
}

.slider_bar_input::-moz-range-thumb:hover {
    background: #1e2329;
}

.slider_bar_input::-moz-range-track {
    width: 100%;
    height: 4px;
    background: transparent;
    border: none;
}

.available_info {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #848e9c;
}

.copy_settings_left .slider_container {
    margin-bottom: 0px;
}

.transfer_link strong {
    font-weight: 500;
}

.available_info span strong {
    color: #ededed;
}

body.light_theme .available_info span strong {
    color: #1e2329;
}

.transfer_link {
    color: #ededed;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
}

body.light_theme .transfer_link {
    color: #1e2329;
}

/* Custom Select Box */
.custom_select_box {
    background: #171a20;
    border-radius: 8px;
    padding: 14px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    position: relative;
}

body.light_theme .custom_select_box {
    background: #F7F7F7;
}

.custom_select_value {
    font-size: 15px;
    color: #c4c4c4;
    font-weight: 500;
}

body.light_theme .custom_select_value {
    color: #070808;
}

.custom_select_arrow {
    color: #848e9c;
    font-size: 18px;
}

.custom_select_options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #ffffff;
    border: 1px solid #eaecef;
    border-radius: 8px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
    z-index: 50;
    margin-top: 4px;
    overflow: hidden;
}

.custom_option {
    padding: 12px 16px;
    font-size: 15px;
    color: #1e2329;
    cursor: pointer;
    transition: background 0.2s;
}

.custom_option:hover {
    background: #f6f8fa;
}

/* Note Text */
.form_note_list {
    margin: 8px 0 0;
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form_note_list li {
    font-size: 12px;
    color: #848e9c;
    line-height: 1.5;
}

/* Collapsible Section */
.more_settings_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 10px 0;
}

.more_settings_header h3 {
    font-size: 16px;
    font-weight: 500;
    color: #d2d2d2;
    margin: 0;
}

body.light_theme .more_settings_header h3 {
    color: #1e2329;
}

.more_settings_content {
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding-top: 4px;
}

.more_settings_content .markets_coins span.coin_icon {
    top: 0px;
    margin: 0px;
    background-color: transparent;
    border: none;
}

/* Toggle Switch */
.toggle_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.toggle_switch {
    position: relative;
    display: inline-block;
    width: 38px;
    height: 20px;
}

.toggle_switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider_toggle {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 24px;
}

.slider_toggle:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 2px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

input:checked+.slider_toggle {
    background-color: #000000;
}

input:checked+.slider_toggle:before {
    transform: translateX(20px);
}

.note_box {
    background: #171a20;
    border-radius: 8px;
    padding: 16px;
    font-size: 14px;
    color: #848e9c;
    line-height: 1.5;
}

body.light_theme .note_box {
    background: #F7F7F7;
}

/* Checkbox Rule */
.checkbox_rule {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 12px;
}

.checkbox_rule input {
    margin-top: 4px;
    cursor: pointer;
}

.checkbox_rule label {
    font-size: 14px;
    color: #ebebeb;
    line-height: 1.4;
    cursor: pointer;
    letter-spacing: -0.40px;
}

body.light_theme .checkbox_rule label {
    color: #1e2329;
}

/* Submit Button */
.btn_submit_copy {
    background: #303236;
    color: #ffffff;
    border: none;
    border-radius: 28px;
    padding: 18px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    text-align: center;
    width: 100%;
    transition: background 0.2s;
    margin-top: 12px;
}

.copy_settings_wrapper.copy_detailpage .container {
    max-width: 1440px;
}

.copy_settings_wrapper.copy_detailpage .copy_settings_left {
    max-width: 100%;
}

.btn_submit_copy:hover {
    background: #2d323e;
}

/* Sidebar Card */
.sidebar_trader_card {
    background: #030405;
    border: 1px solid #eaecef2e;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.03);
}

body.light_theme .sidebar_trader_card {
    background: #ffffff;
    border: 1px solid #eaecef;
}

.stc_header {
    display: flex;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 20px;
}

.stc_avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
}

.stc_avatar_placeholder {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #eaecef;
    color: #1e2329;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
    border: 1px solid #eaecef;
}

.stc_name_section {
    flex: 1 1;
    min-width: 0;
}

.stc_name {
    font-size: 22px;
    font-weight: 700;
    /* color: #1e2329; */
    margin: 0 0 8px 0;
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.stc_name_text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    flex: 1 1;
    min-width: 0;
}

.star_badge {
    color: #A855F7;
    font-size: 16px;
}

.stc_tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.stc_tag_pill {
    background: #f0f1f2;
    color: #848e9c;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
}

.stc_bio {
    font-size: 13px;
    color: #848e9c;
    margin: 0 0 24px;
}

.stc_stats_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    /* border-bottom: 1px solid #eaecef; */
    padding-bottom: 20px;
    margin-bottom: 14px;
}

.stc_stat_item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.stc_stat_label {
    font-size: 14px;
    color: #848e9c;
}

.stc_stat_value {
    font-size: 21px;
    font-weight: 700;
    color: #f2f2f2;
}

body.light_theme .stc_stat_value {
    color: #1e2329;
}

.stc_links {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.stc_link_item {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #848e9c;
    font-size: 15px;
    cursor: pointer;
    transition: color 0.2s;
}

.stc_link_item:hover {
    color: #1e2329;
}

.stc_link_item i {
    font-size: 18px;
}


.clickable_trader_card {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.clickable_trader_card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    border-color: #c8cbd2;
}

.markets_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
}

.markets_right {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.markets_coins {
    display: flex;
    align-items: center;
    margin-right: 6px;
}

.coin_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    position: relative;
    transition: transform 0.2s ease;
}

.coin_icon:hover {
    transform: scale(1.1);
    z-index: 10 !important;
}

.coin_icon svg {
    width: 20px;
    height: 20px;
    display: block;
}

.coin_btc {
    z-index: 3;
}

.coin_eth {
    z-index: 2;
    margin-left: -6px;
}

.coin_green_btc {
    z-index: 1;
    margin-left: -6px;
}

.markets_text {
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 4px;
}


/* Filter Modal Styles */
.filter_modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgb(255 255 255 / 20%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
}

.filter_modal_content {
    background: #ffffff;
    border-radius: 16px;
    width: 560px;
    max-width: 90%;
    max-height: 90vh;
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.filter_modal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #f5f5f5;
}

.filter_modal_header h3 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e2329;
}

.filter_modal_close {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: #848e9c;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
}

.filter_modal_close:hover {
    color: #1e2329;
}

.filter_modal_body {
    padding: 24px;
    overflow-y: auto;
    flex-grow: 1;
}

.filter_section {
    margin-bottom: 24px;
}

.filter_section:last-child {
    margin-bottom: 0;
}

.filter_label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #1e2329;
    margin-bottom: 12px;
}

.filter_buttons_row {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.filter_row_btn {
    flex: 1 1;
    min-width: 80px;
    background: #f5f5f5;
    border: 1px solid transparent;
    border-radius: 8px;
    color: #5e6673;
    font-size: 13px;
    font-weight: 500;
    padding: 10px 0;
    cursor: pointer;
    text-align: center;
    transition: all 0.2s;
}

.filter_row_btn:hover {
    background: #eaecef;
}

.filter_row_btn.active {
    background: #ffffff;
    border-color: #1e2329;
    color: #1e2329;
    font-weight: 600;
}

.filter_range_inputs {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.filter_range_input {
    width: 100%x;
    flex: 1 1;
    background: #f5f5f5;
    border: 1px solid transparent;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: #1e2329;
    outline: none;
    transition: all 0.2s;
    text-align: center;
}

.filter_range_input:focus {
    background: #ffffff;
    border-color: #1e2329;
}

.filter_range_sep {
    color: #848e9c;
    font-size: 14px;
}

.filter_slider_container {
    position: relative;
    height: 24px;
    width: 100%;
    margin: 12px 0;
}

.filter_slider_track {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: #eaecef;
    transform: translateY(-50%);
    z-index: 1;
}

.filter_slider_bar {
    position: absolute;
    height: 100%;
    background: #1e2329;
}

.filter_slider_range_input {
    position: absolute;
    top: 50%;
    width: 100%;
    height: 0;
    margin: 0;
    transform: translateY(-50%);
    background: none;
    pointer-events: none;
    appearance: none;
    z-index: 2;
}

/* Style the range thumb for Webkit (Chrome, Safari, Edge) */
.filter_slider_range_input::-webkit-slider-thumb {
    appearance: none;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ffffff;
    border: 2.5px solid #1e2329;
    cursor: pointer;
    pointer-events: auto;
    /* Allow dragging of the thumb! */
    -webkit-transition: transform 0.1s ease;
    transition: transform 0.1s ease;
}

.filter_slider_range_input::-webkit-slider-thumb:hover {
    transform: scale(1.25);
}

/* Style the range thumb for Firefox */
.filter_slider_range_input::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ffffff;
    border: 2.5px solid #1e2329;
    cursor: pointer;
    pointer-events: auto;
    -moz-transition: transform 0.1s ease;
    transition: transform 0.1s ease;
}

.filter_slider_range_input::-moz-range-thumb:hover {
    transform: scale(1.25);
}

.filter_modal_footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 24px;
    border-top: 1px solid #f5f5f5;
}

.filter_reset_btn {
    background: #f5f5f5;
    border: none;
    border-radius: 20px;
    color: #1e2329;
    font-size: 14px;
    font-weight: 500;
    padding: 10px 24px;
    cursor: pointer;
    transition: background 0.2s;
}

.filter_reset_btn:hover {
    background: #eaecef;
}

.filter_confirm_btn {
    background: #1e2329;
    border: none;
    border-radius: 20px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    padding: 10px 24px;
    cursor: pointer;
    transition: opacity 0.2s;
}

.filter_confirm_btn:hover {
    opacity: 0.9;
}


@media (max-width: 1440px) {

    .copy_settings_wrapper.copy_detailpage .container {
        max-width: 90%;
    }

}

@media (max-width: 1200px) {

    .copy_trading_page_wrapper {
        padding: 15px 0 40px 0;
    }

    .copy_trading_page_wrapper .hero_title {
        font-size: 36px;
    }

    .hero_desc {
        width: 70%;
        font-size: 18px;
        margin: 20px 0px 15px;
    }

    .slide_title {
        max-width: 90%;
        font-size: 22px;
        margin: 18px 0px;
    }

    .hero_slider_card {
        background-size: cover;
    }

    .rt_header_left h2 {
        font-size: 24px;
    }

    .profit_title {
        font-size: 40px;
    }

}

@media (max-width: 1024px) {
    .traders_grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .copy_settings_layout {
        flex-direction: column-reverse;
        gap: 32px;
    }

    .copy_settings_right {
        width: 100%;
        position: relative;
        top: 0;
    }

    .copy_settings_left {
        width: 100%;
        max-width: 100%;
    }

    .copy_settings_wrapper.copy_detailpage .copy_settings_layout {
        flex-direction: row;
    }

    .copy_settings_wrapper.copy_detailpage .copy_settings_right {
        width: 40%;
    }

    .copy_settings_wrapper.copy_detailpage .container {
        max-width: 100%;
    }

    .copy_settings_title {
        font-size: 26px;
        margin: 30px 0px 30px;
    }


}

@media (max-width: 991px) {

    .copy_settings_title {
        font-size: 24px;
        margin: 22px 0px 24px;
    }

    .stc_name {
        font-size: 18px;
    }

    .stc_stat_value {
        font-size: 16px;
    }

    .stc_stat_label {
        font-size: 12px;
    }

    .btn_submit_copy {
        padding: 12px;
        font-size: 14px;
    }

    .copy_trading_page_wrapper .hero_title {
        font-size: 28px;
        margin-bottom: 10px;
    }

    .hero_desc {
        width: 100%;
        font-size: 15px;
    }

    .hero_left {
        max-width: 100%;
        margin-top: 10px;
    }

    .stat_item h3 {
        font-size: 22px;
    }

    .traders_section_wrapper {
        padding: 30px 0;
    }

    .rt_tab {
        font-size: 18px;
    }

    .new_traders_section {
        margin-bottom: 30px;
    }

    .prev_btn {
        width: 24px;
        height: 24px;
        font-size: 17px;
    }

    .next_btn {
        width: 24px;
        height: 24px;
        font-size: 17px;
    }

    .rt_roi .green_text {
        font-size: 16px;
    }

    .rt_user_info h4 {
        font-size: 15px;
    }

    .rt_card .copy_btn {
        padding: 6px 18px;
        font-size: 12px;
    }

    .rt_card {
        padding: 15px;
    }

    .prudent_trader_section {
        margin-top: 10px;
        padding-top: 30px;
    }

    .profit_title {
        font-size: 28px;
        margin-bottom: 20px;
    }

    .btn_apply {
        padding: 10px 24px;
        font-size: 14px;
    }

    .btn_go {
        font-size: 14px;
    }

    .total_profit_section {
        margin-top: 40px;
        padding: 40px 0;
    }


}

@media (max-width:767px) {

    .copy_settings_wrapper.copy_detailpage .copy_settings_layout {
        flex-direction: column;
    }

    .breadcrumbs {
        font-size: 12px;
    }

    .form_label {
        font-size: 13px;
    }

    .note_box {
        padding: 12px;
        font-size: 13px;
    }

    .checkbox_rule label {
        font-size: 12px;
    }

    .btn_submit_copy {
        padding: 10px;
        font-size: 13px;
    }

    .filter_modal_overlay {
        align-items: end;
    }

    .filter_modal_content {
        border-radius: 16px 16px 0px 0px;
        width: 100%;
        max-width: 100%;
    }

    .copy_settings_left {
        gap: 22px;
    }

    .copy_settings_wrapper.copy_detailpage .copy_settings_left .more_settings_header {
        padding: 2px 0;
    }

    .stc_stats_grid {
        gap: 15px;
        padding-bottom: 12px;
        margin-bottom: 10px;
    }

    .copy_settings_wrapper.copy_detailpage .copy_settings_right {
        width: 100%;
    }

    .stc_link_item {
        font-size: 13px;
    }

    .input_box_wrapper input {
        font-size: 12px;
    }

    .input_suffix {
        font-size: 12px;
    }

    .custom_select_value {
        font-size: 13px;
    }

    .copy_settings_title {
        font-size: 20px;
        margin: 16px 0px 20px;
    }

    .rt_card {
        min-height: 90px;
    }

}

@media (max-width: 666px) {

    .tabs_right .help_btn {
        font-size: 12px;
        gap: 6px;
    }

    .tabs_left {
        gap: 10px;
    }

    .tab_btn {
        font-size: 12px;
        padding: 5px 10px;
    }

    .copy_trading_page_wrapper .hero_title {
        font-size: 22px;
    }

    .hero_desc {
        font-size: 14px;
    }

    .stat_item h3 {
        font-size: 18px;
    }

    .copy_trading_hero {
        gap: 20px;
    }

    .slide_title {
        max-width: 100%;
        font-size: 18px;
        margin: 14px 0px;
    }

    .slider_image img {
        max-width: 100px;
    }

    .slide_tag {
        font-size: 14px;
        margin-bottom: 10px;
    }

    .hero_slider_card {
        padding: 10px 20px;
        min-height: 190px;
    }

    .copy_trading_page_wrapper {
        padding: 15px 0 30px 0;
        min-height: 100%;
    }

    .section_header {
        flex-direction: column;
        gap: 15px;
        align-items: start;
        margin-bottom: 20px;
    }

    .section_header h2 {
        font-size: 20px;
    }

    .recommend_tabs {
        gap: 14px;
        margin-bottom: 18px;
    }

    .rt_tab {
        font-size: 15px;
        padding: 5px 0px;
    }

    .traders_grid {
        grid-template-columns: repeat(1, 1fr);
        gap: 18px;
    }

    .tgc_pnl h3 {
        font-size: 20px;
    }

    .rising_talents_section {
        padding-top: 20px;
    }

    .rt_header_left h2 {
        font-size: 20px;
    }

    .rt_header_left p {
        font-size: 13px;
    }

    .more_btn {
        padding: 5px 12px;
        font-size: 13px;
    }

    .rising_talents_list {
        grid-template-columns: repeat(1, 1fr);
        gap: 18px;
    }

    .prudent_trader_section {
        padding-top: 20px;
        margin-bottom: 24px !important;
    }


    .prudent_trader_list {
        grid-template-columns: repeat(1, 1fr);
        gap: 18px;
    }

    .rt_avatar {
        width: 32px;
        height: 32px;
    }

    .medal_icon {
        display: none;
    }

    .profit_subtitle {
        font-size: 15px;
    }

    .profit_title {
        font-size: 24px;
    }

    .btn_apply {
        padding: 8px 24px;
        font-size: 13px;
    }

    .profit_actions {
        padding: 7px;
    }

    .tgc_name_info h4 {
        flex-wrap: wrap;
    }

    .pagination_wrapper {
        display: flex;
        justify-content: center;
        gap: 4px;
        flex-wrap: nowrap;
        margin-top: 24px;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding: 4px 10px;
        box-sizing: border-box;
        scrollbar-width: none;
        /* Hide scrollbar Firefox */
    }

    .pagination_wrapper::-webkit-scrollbar {
        display: none;
        /* Hide scrollbar Chrome/Safari */
    }

    .page_btn {
        width: 28px;
        height: 28px;
        font-size: 12px;
        flex-shrink: 0;
    }

    .page_dots {
        padding: 0;
        margin: 0 2px;
        flex-shrink: 0;
    }

    .cfd_filter_bar {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .cfd_filter_left {
        overflow-x: auto;
        white-space: nowrap;
        padding-bottom: 4px;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
    }

    .cfd_filter_left::-webkit-scrollbar {
        display: none;
    }

    .cfd_filter_right {
        justify-content: space-between;
        gap: 8px;
    }

    .copy_search_wrapper {
        flex-grow: 1;
        width: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/CopyTrading/copytrading.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,yDAAuF;IACvF,wBAAwB;IACxB,kCAAkC;IAClC,4BAA4B;IAC5B,cAAc;IACd,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;8EAE0E;IAC1E,2BAA2B;IAC3B,UAAU;IACV,uEAAuE;IACvE,4BAA4B;IAC5B,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,SAAS;AACT;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yDAAgG;IAChG,wBAAwB;IACxB,kCAAkC;IAClC,4BAA4B;IAC5B,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,uCAAuC;AACvC;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,OAAO;IACP,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,4CAA4C;AAChD;;;AAGA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,yDAAiF;IACjF,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;;AAGA,0BAA0B;AAC1B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,4CAA4C;IAC5C,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,cAAc;AAClB;;;AAGA,qCAAqC;AACrC;IACI,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;AACb;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,0CAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,YAAY;AAChB;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,uCAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;IAC5C,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,sCAAsC;IACtC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,6EAA6E;AACjF;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;;AAGA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;IAEpB,gBAAgB;IAChB,UAAU;AACd;;AAEA,4DAA4D;AAC5D;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,iCAAiC;IACjC,uCAA+B;IAA/B,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,oCAA+B;IAA/B,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;;AAGA;;IAEI;QACI,cAAc;IAClB;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;IACV;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;;;AAGJ;;AAEA;;IAEI;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;;AAGJ;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gCAAgC;QAChC,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,8BAA8B;IAClC;;;IAGA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,QAAQ;QACR,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,gBAAgB;QAChB,iCAAiC;QACjC,iBAAiB;QACjB,sBAAsB;QACtB,qBAAqB;QACrB,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,iCAAiC;IACrC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,iCAAiC;QACjC,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;AACJ","sourcesContent":["/* Copy Trading Page CSS */\n.copy_trading_page_wrapper {\n    background-color: #000000;\n    background-image: url(\"../../../../public/images/copy-trading-img/copy_trandingbg.jpg\");\n    background-size: contain;\n    background-position: bottom center;\n    background-repeat: no-repeat;\n    color: #ffffff;\n    min-height: 540px;\n    border-radius: 0px 0px 24px 24px;\n    padding: 0 0 60px 0;\n    /* font-family: \"Inter\", sans-serif; */\n    position: relative;\n    overflow: hidden;\n}\n\n\n.tabs_right {\n    margin-top: -11px;\n}\n\n.hero_grid_bg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image:\n        linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n    background-size: 100px 50px;\n    z-index: 0;\n    transform: perspective(1000px) rotateX(75deg) translateY(-20%) scale(2);\n    transform-origin: top center;\n    opacity: 0.8;\n    pointer-events: none;\n}\n\n.copy_trading_page_wrapper .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0px 20px;\n    position: relative;\n    z-index: 1;\n}\n\n/* Tabs */\n.copy_trading_top_nav {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 0 0px;\n}\n\n.copy_trading_top_bar {\n    width: 100%;\n    display: block;\n    border-bottom: 1px solid #ffffff20;\n    margin-bottom: 32px;\n}\n\n.tabs_left {\n    display: flex;\n    gap: 20px;\n}\n\n.tab_btn {\n    background: none;\n    border: none;\n    color: #848e9c;\n    font-size: 14px;\n    cursor: pointer;\n    padding-bottom: 10px;\n    position: relative;\n}\n\n.tab_btn.active {\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.tab_btn.active::after {\n    content: '';\n    position: absolute;\n    bottom: -10px;\n    left: 0;\n    width: 35%;\n    height: 2px;\n    background-color: #ffffff;\n    margin: 0 auto;\n    right: 0px;\n}\n\n.tabs_right .help_btn {\n    background: none;\n    border: none;\n    color: #ffffff;\n    font-size: 14px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.help_btn:hover {\n    color: #ffffff;\n}\n\n/* Hero Section */\n.copy_trading_hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 40px;\n}\n\n.hero_left {\n    flex: 1 1;\n    max-width: 320px;\n    margin-top: 32px;\n}\n\n.copy_trading_top_bar .container {\n    max-width: 1440px;\n}\n\n\n.copy_trading_page_wrapper .hero_title {\n    font-size: 48px;\n    font-weight: 600;\n    margin-bottom: 30px;\n}\n\n.hero_desc {\n    width: 65%;\n    font-size: 20px;\n    color: #ffffff;\n    line-height: 1.5;\n    margin: 40px 0px 15px;\n}\n\n.hero_stats {\n    display: flex;\n    gap: 40px;\n}\n\n.stat_item h3 {\n    font-size: 28px;\n    font-weight: 700;\n    margin-bottom: 5px;\n}\n\n.stat_item p {\n    font-size: 14px;\n    color: #E3E3E3;\n    margin: 0;\n}\n\n/* Slider Card */\n.hero_right {\n    flex: 1 1;\n    max-width: 792px;\n}\n\n.hero_slider_card {\n    background: #000000;\n    background-image: url(\"../../../../public/images/copy-trading-img/copytrading_herobgslider.jpg\");\n    background-size: contain;\n    background-position: bottom center;\n    background-repeat: no-repeat;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    padding: 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    min-height: 275px;\n}\n\n.slider_content {\n    flex: 1;\n}\n\n.slide_tag {\n    color: #fff;\n    font-size: 18px;\n    margin-bottom: 15px;\n    display: inline-block;\n    position: relative;\n}\n\n.slide_tag::after {\n    content: '';\n    position: absolute;\n    bottom: -8px;\n    left: 0;\n    width: 24px;\n    height: 2px;\n    background-color: #cca450;\n}\n\n.slide_title {\n    max-width: 80%;\n    font-size: 28px;\n    font-weight: 500;\n    margin: 24px 0px;\n    /* margin-top: 25px; */\n    line-height: 1.3;\n}\n\n.slide_subtitle {\n    font-size: 26px;\n    font-weight: 500;\n    margin-bottom: 30px;\n    line-height: 1.3;\n    margin-top: 0;\n}\n\n.slide_link {\n    background: none;\n    border: none;\n    color: #ffffff;\n    font-size: 14px;\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n}\n\n.slide_link:hover {\n    color: #cca450;\n}\n\n.slider_image {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.slider_image img {\n    max-width: 190px;\n    height: auto;\n}\n\n.slider_pagination {\n    position: absolute;\n    bottom: 25px;\n    right: 40px;\n    display: flex;\n    gap: 6px;\n}\n\n.slider_pagination .dot {\n    width: 6px;\n    height: 6px;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.slider_pagination .dot.active {\n    width: 20px;\n    border-radius: 4px;\n    background: #ffffff;\n}\n\n@media (max-width: 768px) {\n    .copy_trading_hero {\n        flex-direction: column;\n    }\n\n    .hero_right {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n/* --- Traders Section Below Hero --- */\n.traders_section_wrapper {\n    background-color: #000;\n    color: #1e2329;\n    padding: 60px 0;\n    font-family: \"Inter\", sans-serif;\n}\n\nbody.light_theme .traders_section_wrapper {\n    background-color: #ffffff;\n}\n\n.traders_section_wrapper .container {\n    max-width: 1440px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n/* New Traders */\n.new_traders_section {\n    margin-bottom: 60px;\n}\n\n.section_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.section_header h2 {\n    font-size: 22px;\n    font-weight: 700;\n    color: #ececec;\n    margin: 0;\n}\n\nbody.light_theme .section_header h2 {\n    color: #1e2329;\n}\n\n.header_actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.icon_btn {\n    background: none;\n    cursor: pointer;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n\n.icon_btn img {\n    width: 20px;\n}\n\n.search_bar {\n    display: flex;\n    align-items: center;\n    background: #ffffff08;\n    border: 1px solid #c8c8c840;\n    border-radius: 12px;\n    padding: 8px 12px;\n    width: 250px;\n}\n\nbody.light_theme .search_bar {\n    background: #ffffff;\n    border: 1px solid #c8c8c8;\n}\n\n.search_bar i {\n    font-size: 16px;\n    color: #dbdbdb;\n}\n\nbody.light_theme .search_bar i {\n    color: #000000;\n}\n\n.search_bar input {\n    border: none;\n    outline: none;\n    background: transparent;\n    margin-left: 8px;\n    font-size: 14px;\n    color: #dbdbdb;\n    width: 100%;\n}\n\nbody.light_theme .search_bar input {\n    color: #1e2329;\n}\n\n.new_traders_list {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    padding-bottom: 10px;\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n}\n\n.new_traders_list::-webkit-scrollbar {\n    display: none;\n}\n\n.new_trader_card {\n    flex: 0 0 auto;\n    min-width: 280px;\n    display: flex;\n    min-height: 82px;\n    align-items: center;\n    background: #ffffff0a;\n    border: 1px solid #eaecef21;\n    color: #fff;\n    border-radius: 12px;\n    padding: 16px;\n    gap: 12px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);\n    position: relative;\n}\n\nbody.light_theme .new_trader_card {\n    color: #ffffff96;\n    background: #ffffff;\n    border: 1px solid #eaecef;\n}\n\n.nt_avatar {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.nt_info h4 {\n    font-size: 12px;\n    font-weight: 500;\n    color: #e5e5e5;\n    margin: 0 0 4px 0;\n}\n\nbody.light_theme .nt_info h4 {\n    color: #000;\n}\n\n.nt_info p {\n    font-size: 14px;\n    color: #848e9c;\n    font-weight: 500;\n    margin: 0;\n}\n\n.nt_info p strong {\n    color: #1e2329;\n}\n\n.green_text {\n    color: #00B47D;\n    margin-left: 6px;\n}\n\n.arrow_right {\n    position: absolute;\n    right: 16px;\n    color: #848e9c;\n    font-size: 18px;\n}\n\n.next_btn {\n    position: absolute;\n    right: -20px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 40px;\n    padding: 0px;\n    height: 40px;\n    border-radius: 50%;\n    background: #ffffff;\n    color: #1e2329;\n    border: 1px solid #eaecef;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    cursor: pointer;\n    z-index: 2;\n}\n\n.prev_btn {\n    position: absolute;\n    left: -20px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 40px;\n    height: 40px;\n    padding: 0px;\n    border-radius: 50%;\n    background: #ffffff;\n    color: #1e2329;\n    border: 1px solid #eaecef;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    cursor: pointer;\n    z-index: 2;\n}\n\n/* Recommend Section */\n.recommend_tabs {\n    display: flex;\n    gap: 32px;\n    margin-bottom: 24px;\n}\n\n.rt_tab {\n    background: none;\n    border: none;\n    font-size: 22px;\n    font-weight: 700;\n    color: #848e9c;\n    cursor: pointer;\n    padding-bottom: 16px;\n    position: relative;\n}\n\n.rt_tab.active {\n    color: #fff;\n}\n\nbody.light_theme .rt_tab.active {\n    color: #1e2329;\n}\n\nbody.light_theme .rt_tab.active::after {\n    background: #1e2329;\n}\n\n.rt_tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    right: 0px;\n    left: 0;\n    margin: 0 auto;\n    width: 32px;\n    height: 3px;\n    background: #fbfbfb;\n    border-radius: 2px;\n}\n\n/* Grid */\n.traders_grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n}\n\n.trader_grid_card {\n    background: #ffffff0a;\n    border: 1px solid #eaecef21;\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.02);\n}\n\n\nbody.light_theme .trader_grid_card {\n    background: #ffffff;\n    border: 1px solid #eaecef;\n}\n\n.tgc_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 24px;\n}\n\n.tgc_user {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.tgc_avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #fefefe;\n    color: #1e2329;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 400;\n    border: 1px solid #eaecef;\n}\n\n.tgc_avatar_img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.tgc_name_info h4 {\n    font-size: 16px;\n    font-weight: 400;\n    margin: 0 0 4px 0;\n    color: #fffffff7;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\nbody.light_theme .tgc_name_info h4 {\n    color: #000000;\n}\n\n.tgc_label {\n    font-size: 10px;\n    background: #f0f0ff;\n    color: #7b61ff;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-weight: 500;\n}\n\n.tgc_name_info p {\n    font-size: 12px;\n    color: #848e9c;\n    margin: 0;\n}\n\n.copy_btn {\n    background: #1D1D1D;\n    color: #ffffff;\n    border: none;\n    padding: 6px 16px;\n    border-radius: 20px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.tgc_chart_section {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n}\n\n.tgc_pnl {\n    flex: 1;\n}\n\n.pnl_label {\n    font-size: 13px;\n    color: #848e9c;\n    margin: 0 0 4px 0;\n}\n\n.tgc_pnl h3 {\n    font-size: 24px;\n    margin: 0 0 4px 0;\n}\n\n.usdt_text {\n    font-size: 12px;\n    color: #86898d;\n    margin: 0;\n    font-weight: 500;\n}\n\nbody.light_theme .usdt_text {\n    color: #1e2329;\n}\n\n.tgc_chart {\n    max-width: 130px;\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.tgc_chart img {\n    height: 40px;\n    object-fit: contain;\n}\n\n.tgc_stats {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.tgc_stat_row {\n    display: flex;\n    justify-content: space-between;\n    font-size: 13px;\n}\n\n.tgc_stat_row span {\n    color: #848e9c;\n}\n\n.tgc_stat_row strong {\n    color: #cbcbcb;\n    font-weight: 500;\n}\n\nbody.light_theme .tgc_stat_row strong {\n    color: #1e2329;\n}\n\n/* Pagination */\n.pagination_wrapper {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 8px;\n    margin-top: 32px;\n}\n\n.page_btn {\n    background: #080808;\n    border: 1px solid #eaecef1a;\n    border-radius: 4px;\n    color: #ffffff;\n    font-size: 14px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\nbody.light_theme .page_btn {\n    background: #ffffff;\n    border: 1px solid #eaecef;\n    color: #1e2329;\n\n}\n\n.page_btn:hover {\n    background: #f5f5f5;\n}\n\n.page_btn.active {\n    border-color: #1e2329;\n    font-weight: 600;\n}\n\n.page_dots {\n    color: #848e9c;\n    padding: 0 4px;\n}\n\n/* Rising Talents Section */\n.rising_talents_section {\n    margin-top: 20px;\n    padding-top: 40px;\n}\n\n.rt_header_wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 24px;\n}\n\n.rt_header_left h2 {\n    font-size: 30px;\n    font-weight: 700;\n    color: #f5f5f5;\n    margin: 0 0 8px 0;\n}\n\nbody.light_theme .rt_header_left h2 {\n    color: #1e2329;\n}\n\n.rt_header_left p {\n    font-size: 16px;\n    padding-top: 5px;\n    color: #848e9c;\n    margin: 0;\n}\n\n.more_btn {\n    background: #ffffff12;\n    border: 1px solid #eaecef26;\n    border-radius: 20px;\n    padding: 6px 16px;\n    font-size: 14px;\n    color: #1e2329;\n    cursor: pointer;\n    font-weight: 500;\n}\n\nbody.light_theme .more_btn {\n    background: #ffffff;\n    border: 1px solid #eaecef;\n}\n\n/* .more_btn:hover {\n    background: #f5f5f5;\n} */\n\n.rising_talents_list {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n}\n\n.rt_card {\n    background: #0808080d;\n    border: 1px solid #e9eaeb0f;\n    border-radius: 16px;\n    padding: 24px;\n    min-height: 106px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\nbody.light_theme .rt_card {\n    background: #080808;\n    border: 1px solid #e9eaeb17;\n}\n\nbody.light_theme .rt_card {\n    background: #ffffff;\n    border: 1px solid #e9eaeb;\n}\n\nbody .market-table-container {\n    background-color: transparent;\n}\n\n.rt_user {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n}\n\n.rt_avatar {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\nbody.light_theme .rt_user_info h4 {\n    color: #000;\n}\n\n.rt_user_info h4 {\n    font-size: 18px;\n    color: #fff;\n    font-weight: 700;\n    margin: 0 0 4px 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.medal_icon {\n    width: 20px;\n    height: 20px;\n    margin-left: 10px;\n}\n\n.rt_user_info p {\n    font-size: 12px;\n    color: #848e9c;\n    margin: 0;\n}\n\n.rt_roi {\n    flex: 1;\n    text-align: left;\n    padding-left: 20px;\n}\n\n.rt_roi .roi_label {\n    font-size: 12px;\n    color: #848e9c;\n    margin: 0 0 4px 0;\n}\n\n.rt_roi .green_text {\n    font-size: 20px;\n    margin: 0;\n    font-weight: 700;\n}\n\n.rt_card .copy_btn {\n    background: #2a2e39;\n    color: #ffffff;\n    padding: 10px 24px;\n    border-radius: 20px;\n    font-weight: 500;\n}\n\n/* Prudent Trader Section */\n.prudent_trader_section {\n    margin-top: 30px;\n    padding-top: 40px;\n}\n\n.prudent_trader_list {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n}\n\n.lock_btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: #3c404a !important;\n}\n\n.lock_icon {\n    width: 12px;\n    height: 12px;\n}\n\n/* Total Profit Sharing Section */\n.total_profit_section {\n    margin-top: 60px;\n    background-image: url(\"../../../../public/images/copy-trading-img/exceedsbg.jpg\");\n    background-size: cover;\n    background-position: center;\n    border-radius: 16px;\n    padding: 60px 0;\n    text-align: center;\n    color: #ffffff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.profit_subtitle {\n    font-size: 20px;\n    margin: 0 0 16px 0;\n    color: #e6e8eb;\n}\n\n.profit_title {\n    font-size: 56px;\n    font-weight: 700;\n    color: #dfb065;\n    margin: 0 0 40px 0;\n}\n\n.profit_actions {\n    display: flex;\n    gap: 16px;\n}\n\n.btn_apply {\n    background: #dfb065;\n    color: #1e2329;\n    border: none;\n    border-radius: 24px;\n    padding: 12px 32px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.profit_actions {\n    display: flex;\n    gap: 16px;\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 50px;\n    padding: 12px;\n    gap: 8px;\n}\n\n.btn_go {\n    background: none;\n    color: #ffffff;\n    border: none;\n    border-radius: 24px;\n    padding: 0px 10px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n\n/* CFD Filter Bar Styles */\n.cfd_filter_bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.cfd_filter_left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.cfd_filter_btn {\n    background: none;\n    border: none;\n    font-size: 14px;\n    font-weight: 500;\n    color: #848e9c;\n    cursor: pointer;\n    padding: 8px 16px;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n}\n\n.cfd_filter_btn:hover {\n    color: #1e2329;\n    background-color: #f5f5f5;\n}\n\n.cfd_filter_btn.active {\n    background: #f5f5f5;\n    color: #1e2329;\n    font-weight: 600;\n}\n\n.cfd_filter_right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.copy_filter_btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: #ffffff;\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #1e2329;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    height: 38px;\n    box-sizing: border-box;\n}\n\n.copy_filter_btn:hover {\n    background-color: #f5f5f5;\n}\n\n.copy_filter_btn i {\n    font-size: 16px;\n}\n\n.copy_search_wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    background: #f5f5f5;\n    border-radius: 8px;\n    padding: 8px 12px;\n    width: 200px;\n    height: 38px;\n    box-sizing: border-box;\n    transition: all 0.2s ease;\n}\n\n.copy_search_wrapper:focus-within {\n    background: #ffffff;\n    box-shadow: 0 0 0 1px #1e2329;\n}\n\n.copy_search_icon {\n    color: #848e9c;\n    margin-right: 8px;\n    font-size: 16px;\n}\n\n.copy_search_input {\n    background: transparent;\n    border: none;\n    outline: none;\n    width: 100%;\n    font-size: 14px;\n    color: #1e2329;\n}\n\n.copy_search_input::placeholder {\n    color: #848e9c;\n}\n\n.cfd_dropdown {\n    position: relative;\n}\n\n.cfd_dropdown_btn {\n    background: #ffffff;\n    color: #1e2329;\n    border: 1px solid #e8e8e8;\n    border-radius: 8px;\n    padding: 10px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 140px;\n    transition: all 0.2s ease;\n}\n\n.cfd_dropdown_btn:hover {\n    background: #f8f9fa;\n}\n\n.cfd_dropdown_menu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 8px;\n    background: #ffffff;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.06);\n    z-index: 100;\n    min-width: 140px;\n    padding: 8px 0;\n    overflow: hidden;\n}\n\n.cfd_dropdown_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 12px 16px;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    color: #1e2329;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.cfd_dropdown_item:hover {\n    background: #f8f9fa;\n}\n\n.cfd_check_circle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background-color: #000000;\n    color: #ffffff;\n    font-size: 8px;\n}\n\n\n/* Copy Settings Detail Page Styles */\n.copy_settings_wrapper {\n    background-color: #000000;\n    color: #ffffff;\n    padding: 40px 0 80px;\n    font-family: \"Inter\", sans-serif;\n}\n\nbody.light_theme .copy_settings_wrapper {\n    background-color: #ffffff;\n    color: #1e2329;\n}\n\n.copy_settings_wrapper .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.breadcrumbs {\n    font-size: 14px;\n    color: #848e9c;\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.breadcrumbs span:first-child {\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.breadcrumbs span:first-child:hover {\n    color: #1e2329;\n}\n\n.copy_settings_title {\n    font-size: 32px;\n    font-weight: 600;\n    margin: 70px 0px 30px;\n}\n\n.copy_settings_layout {\n    display: flex;\n    gap: 40px;\n    align-items: flex-start;\n}\n\n.copy_settings_left {\n    flex: 1;\n    max-width: 720px;\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n}\n\n.copy_settings_right {\n    width: 380px;\n    position: sticky;\n    top: 20px;\n}\n\n/* Form Group */\n.form_group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.form_label {\n    font-size: 16px;\n    font-weight: 500;\n    color: #a6a6a6;\n    letter-spacing: -0.40px;\n}\n\nbody.light_theme .form_label {\n    color: #1e2329;\n}\n\n.input_box_wrapper {\n    background: #171a20;\n    border-radius: 8px;\n    padding: 14px 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\nbody.light_theme .input_box_wrapper {\n    background: #F7F7F7;\n}\n\n.input_box_wrapper input {\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 16px;\n    color: #9b9b9b;\n    width: 70%;\n}\n\n.input_box_wrapper input::placeholder {\n    color: #9b9b9b;\n}\n\n.input_suffix {\n    font-size: 14px;\n    color: #848e9c;\n    font-weight: 500;\n}\n\n.input_suffix_max {\n    color: #BE995B;\n    font-weight: 500;\n    cursor: pointer;\n    margin-left: 2px;\n}\n\n/* Slider Style */\n.slider_container {\n    position: relative;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n.slider_track_wrapper {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 50%;\n    height: 4px;\n    background: #171a20;\n    border-radius: 2px;\n    transform: translateY(-50%);\n    pointer-events: none;\n    z-index: 1;\n}\n\nbody.light_theme .slider_track_wrapper {\n    background: #eaecef;\n}\n\n.slider_dots {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    justify-content: space-between;\n    pointer-events: none;\n    z-index: 2;\n}\n\n.slider_dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #eaecef;\n    border: 2px solid #ffffff;\n    box-shadow: 0 0 0 1px #eaecef;\n    transition: all 0.2s ease;\n}\n\n.slider_dot.active {\n    background: #c8cbd2;\n    box-shadow: 0 0 0 1px #c8cbd2;\n}\n\n.slider_bar_input {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 100%;\n    height: 4px;\n    background: transparent;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 3;\n    outline: none;\n    margin: 0;\n    cursor: pointer;\n}\n\n/* Chrome, Safari, Edge, Opera */\n.slider_bar_input::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background: #c8cbd2;\n    border: 2px solid #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    margin-top: -4px;\n    transition: background-color 0.15s;\n}\n\n.slider_bar_input::-webkit-slider-thumb:hover {\n    background: #1e2329;\n}\n\n.slider_bar_input::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    background: transparent;\n    border: none;\n}\n\n/* Firefox */\n.slider_bar_input::-moz-range-thumb {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background: #c8cbd2;\n    border: 2px solid #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    transition: background-color 0.15s;\n}\n\n.slider_bar_input::-moz-range-thumb:hover {\n    background: #1e2329;\n}\n\n.slider_bar_input::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    background: transparent;\n    border: none;\n}\n\n.available_info {\n    display: flex;\n    justify-content: space-between;\n    font-size: 13px;\n    color: #848e9c;\n}\n\n.copy_settings_left .slider_container {\n    margin-bottom: 0px;\n}\n\n.transfer_link strong {\n    font-weight: 500;\n}\n\n.available_info span strong {\n    color: #ededed;\n}\n\nbody.light_theme .available_info span strong {\n    color: #1e2329;\n}\n\n.transfer_link {\n    color: #ededed;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\nbody.light_theme .transfer_link {\n    color: #1e2329;\n}\n\n/* Custom Select Box */\n.custom_select_box {\n    background: #171a20;\n    border-radius: 8px;\n    padding: 14px 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n}\n\nbody.light_theme .custom_select_box {\n    background: #F7F7F7;\n}\n\n.custom_select_value {\n    font-size: 15px;\n    color: #c4c4c4;\n    font-weight: 500;\n}\n\nbody.light_theme .custom_select_value {\n    color: #070808;\n}\n\n.custom_select_arrow {\n    color: #848e9c;\n    font-size: 18px;\n}\n\n.custom_select_options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: #ffffff;\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);\n    z-index: 50;\n    margin-top: 4px;\n    overflow: hidden;\n}\n\n.custom_option {\n    padding: 12px 16px;\n    font-size: 15px;\n    color: #1e2329;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.custom_option:hover {\n    background: #f6f8fa;\n}\n\n/* Note Text */\n.form_note_list {\n    margin: 8px 0 0;\n    padding-left: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.form_note_list li {\n    font-size: 12px;\n    color: #848e9c;\n    line-height: 1.5;\n}\n\n/* Collapsible Section */\n.more_settings_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    padding: 10px 0;\n}\n\n.more_settings_header h3 {\n    font-size: 16px;\n    font-weight: 500;\n    color: #d2d2d2;\n    margin: 0;\n}\n\nbody.light_theme .more_settings_header h3 {\n    color: #1e2329;\n}\n\n.more_settings_content {\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n    padding-top: 4px;\n}\n\n.more_settings_content .markets_coins span.coin_icon {\n    top: 0px;\n    margin: 0px;\n    background-color: transparent;\n    border: none;\n}\n\n/* Toggle Switch */\n.toggle_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.toggle_switch {\n    position: relative;\n    display: inline-block;\n    width: 38px;\n    height: 20px;\n}\n\n.toggle_switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider_toggle {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    transition: .4s;\n    border-radius: 24px;\n}\n\n.slider_toggle:before {\n    position: absolute;\n    content: \"\";\n    height: 16px;\n    width: 16px;\n    left: 3px;\n    bottom: 2px;\n    background-color: white;\n    transition: .4s;\n    border-radius: 50%;\n}\n\ninput:checked+.slider_toggle {\n    background-color: #000000;\n}\n\ninput:checked+.slider_toggle:before {\n    transform: translateX(20px);\n}\n\n.note_box {\n    background: #171a20;\n    border-radius: 8px;\n    padding: 16px;\n    font-size: 14px;\n    color: #848e9c;\n    line-height: 1.5;\n}\n\nbody.light_theme .note_box {\n    background: #F7F7F7;\n}\n\n/* Checkbox Rule */\n.checkbox_rule {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    margin-top: 12px;\n}\n\n.checkbox_rule input {\n    margin-top: 4px;\n    cursor: pointer;\n}\n\n.checkbox_rule label {\n    font-size: 14px;\n    color: #ebebeb;\n    line-height: 1.4;\n    cursor: pointer;\n    letter-spacing: -0.40px;\n}\n\nbody.light_theme .checkbox_rule label {\n    color: #1e2329;\n}\n\n/* Submit Button */\n.btn_submit_copy {\n    background: #303236;\n    color: #ffffff;\n    border: none;\n    border-radius: 28px;\n    padding: 18px;\n    font-size: 16px;\n    font-weight: 400;\n    cursor: pointer;\n    text-align: center;\n    width: 100%;\n    transition: background 0.2s;\n    margin-top: 12px;\n}\n\n.copy_settings_wrapper.copy_detailpage .container {\n    max-width: 1440px;\n}\n\n.copy_settings_wrapper.copy_detailpage .copy_settings_left {\n    max-width: 100%;\n}\n\n.btn_submit_copy:hover {\n    background: #2d323e;\n}\n\n/* Sidebar Card */\n.sidebar_trader_card {\n    background: #030405;\n    border: 1px solid #eaecef2e;\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .sidebar_trader_card {\n    background: #ffffff;\n    border: 1px solid #eaecef;\n}\n\n.stc_header {\n    display: flex;\n    gap: 16px;\n    align-items: flex-start;\n    margin-bottom: 20px;\n}\n\n.stc_avatar {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.stc_avatar_placeholder {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background: #eaecef;\n    color: #1e2329;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    font-weight: 700;\n    border: 1px solid #eaecef;\n}\n\n.stc_name_section {\n    flex: 1;\n    min-width: 0;\n}\n\n.stc_name {\n    font-size: 22px;\n    font-weight: 700;\n    /* color: #1e2329; */\n    margin: 0 0 8px 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n}\n\n.stc_name_text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-block;\n    flex: 1;\n    min-width: 0;\n}\n\n.star_badge {\n    color: #A855F7;\n    font-size: 16px;\n}\n\n.stc_tags {\n    display: flex;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.stc_tag_pill {\n    background: #f0f1f2;\n    color: #848e9c;\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-weight: 500;\n}\n\n.stc_bio {\n    font-size: 13px;\n    color: #848e9c;\n    margin: 0 0 24px;\n}\n\n.stc_stats_grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    /* border-bottom: 1px solid #eaecef; */\n    padding-bottom: 20px;\n    margin-bottom: 14px;\n}\n\n.stc_stat_item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.stc_stat_label {\n    font-size: 14px;\n    color: #848e9c;\n}\n\n.stc_stat_value {\n    font-size: 21px;\n    font-weight: 700;\n    color: #f2f2f2;\n}\n\nbody.light_theme .stc_stat_value {\n    color: #1e2329;\n}\n\n.stc_links {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.stc_link_item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #848e9c;\n    font-size: 15px;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.stc_link_item:hover {\n    color: #1e2329;\n}\n\n.stc_link_item i {\n    font-size: 18px;\n}\n\n\n.clickable_trader_card {\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.clickable_trader_card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n    border-color: #c8cbd2;\n}\n\n.markets_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 0;\n}\n\n.markets_right {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.markets_coins {\n    display: flex;\n    align-items: center;\n    margin-right: 6px;\n}\n\n.coin_icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    position: relative;\n    transition: transform 0.2s ease;\n}\n\n.coin_icon:hover {\n    transform: scale(1.1);\n    z-index: 10 !important;\n}\n\n.coin_icon svg {\n    width: 20px;\n    height: 20px;\n    display: block;\n}\n\n.coin_btc {\n    z-index: 3;\n}\n\n.coin_eth {\n    z-index: 2;\n    margin-left: -6px;\n}\n\n.coin_green_btc {\n    z-index: 1;\n    margin-left: -6px;\n}\n\n.markets_text {\n    font-weight: 500;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n\n/* Filter Modal Styles */\n.filter_modal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgb(255 255 255 / 20%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 99999999;\n    backdrop-filter: blur(5px);\n}\n\n.filter_modal_content {\n    background: #ffffff;\n    border-radius: 16px;\n    width: 560px;\n    max-width: 90%;\n    max-height: 90vh;\n    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.15);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.filter_modal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #f5f5f5;\n}\n\n.filter_modal_header h3 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #1e2329;\n}\n\n.filter_modal_close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 20px;\n    color: #848e9c;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s;\n}\n\n.filter_modal_close:hover {\n    color: #1e2329;\n}\n\n.filter_modal_body {\n    padding: 24px;\n    overflow-y: auto;\n    flex-grow: 1;\n}\n\n.filter_section {\n    margin-bottom: 24px;\n}\n\n.filter_section:last-child {\n    margin-bottom: 0;\n}\n\n.filter_label {\n    display: block;\n    font-size: 14px;\n    font-weight: 500;\n    color: #1e2329;\n    margin-bottom: 12px;\n}\n\n.filter_buttons_row {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.filter_row_btn {\n    flex: 1;\n    min-width: 80px;\n    background: #f5f5f5;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    color: #5e6673;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 10px 0;\n    cursor: pointer;\n    text-align: center;\n    transition: all 0.2s;\n}\n\n.filter_row_btn:hover {\n    background: #eaecef;\n}\n\n.filter_row_btn.active {\n    background: #ffffff;\n    border-color: #1e2329;\n    color: #1e2329;\n    font-weight: 600;\n}\n\n.filter_range_inputs {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.filter_range_input {\n    width: 100%x;\n    flex: 1;\n    background: #f5f5f5;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    padding: 10px 12px;\n    font-size: 14px;\n    color: #1e2329;\n    outline: none;\n    transition: all 0.2s;\n    text-align: center;\n}\n\n.filter_range_input:focus {\n    background: #ffffff;\n    border-color: #1e2329;\n}\n\n.filter_range_sep {\n    color: #848e9c;\n    font-size: 14px;\n}\n\n.filter_slider_container {\n    position: relative;\n    height: 24px;\n    width: 100%;\n    margin: 12px 0;\n}\n\n.filter_slider_track {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: #eaecef;\n    transform: translateY(-50%);\n    z-index: 1;\n}\n\n.filter_slider_bar {\n    position: absolute;\n    height: 100%;\n    background: #1e2329;\n}\n\n.filter_slider_range_input {\n    position: absolute;\n    top: 50%;\n    width: 100%;\n    height: 0;\n    margin: 0;\n    transform: translateY(-50%);\n    background: none;\n    pointer-events: none;\n    -webkit-appearance: none;\n    appearance: none;\n    z-index: 2;\n}\n\n/* Style the range thumb for Webkit (Chrome, Safari, Edge) */\n.filter_slider_range_input::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    background: #ffffff;\n    border: 2.5px solid #1e2329;\n    cursor: pointer;\n    pointer-events: auto;\n    /* Allow dragging of the thumb! */\n    transition: transform 0.1s ease;\n}\n\n.filter_slider_range_input::-webkit-slider-thumb:hover {\n    transform: scale(1.25);\n}\n\n/* Style the range thumb for Firefox */\n.filter_slider_range_input::-moz-range-thumb {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    background: #ffffff;\n    border: 2.5px solid #1e2329;\n    cursor: pointer;\n    pointer-events: auto;\n    transition: transform 0.1s ease;\n}\n\n.filter_slider_range_input::-moz-range-thumb:hover {\n    transform: scale(1.25);\n}\n\n.filter_modal_footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 16px 24px;\n    border-top: 1px solid #f5f5f5;\n}\n\n.filter_reset_btn {\n    background: #f5f5f5;\n    border: none;\n    border-radius: 20px;\n    color: #1e2329;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 10px 24px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.filter_reset_btn:hover {\n    background: #eaecef;\n}\n\n.filter_confirm_btn {\n    background: #1e2329;\n    border: none;\n    border-radius: 20px;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 10px 24px;\n    cursor: pointer;\n    transition: opacity 0.2s;\n}\n\n.filter_confirm_btn:hover {\n    opacity: 0.9;\n}\n\n\n@media (max-width: 1440px) {\n\n    .copy_settings_wrapper.copy_detailpage .container {\n        max-width: 90%;\n    }\n\n}\n\n@media (max-width: 1200px) {\n\n    .copy_trading_page_wrapper {\n        padding: 15px 0 40px 0;\n    }\n\n    .copy_trading_page_wrapper .hero_title {\n        font-size: 36px;\n    }\n\n    .hero_desc {\n        width: 70%;\n        font-size: 18px;\n        margin: 20px 0px 15px;\n    }\n\n    .slide_title {\n        max-width: 90%;\n        font-size: 22px;\n        margin: 18px 0px;\n    }\n\n    .hero_slider_card {\n        background-size: cover;\n    }\n\n    .rt_header_left h2 {\n        font-size: 24px;\n    }\n\n    .profit_title {\n        font-size: 40px;\n    }\n\n}\n\n@media (max-width: 1024px) {\n    .traders_grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .copy_settings_layout {\n        flex-direction: column-reverse;\n        gap: 32px;\n    }\n\n    .copy_settings_right {\n        width: 100%;\n        position: relative;\n        top: 0;\n    }\n\n    .copy_settings_left {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .copy_settings_wrapper.copy_detailpage .copy_settings_layout {\n        flex-direction: row;\n    }\n\n    .copy_settings_wrapper.copy_detailpage .copy_settings_right {\n        width: 40%;\n    }\n\n    .copy_settings_wrapper.copy_detailpage .container {\n        max-width: 100%;\n    }\n\n    .copy_settings_title {\n        font-size: 26px;\n        margin: 30px 0px 30px;\n    }\n\n\n}\n\n@media (max-width: 991px) {\n\n    .copy_settings_title {\n        font-size: 24px;\n        margin: 22px 0px 24px;\n    }\n\n    .stc_name {\n        font-size: 18px;\n    }\n\n    .stc_stat_value {\n        font-size: 16px;\n    }\n\n    .stc_stat_label {\n        font-size: 12px;\n    }\n\n    .btn_submit_copy {\n        padding: 12px;\n        font-size: 14px;\n    }\n\n    .copy_trading_page_wrapper .hero_title {\n        font-size: 28px;\n        margin-bottom: 10px;\n    }\n\n    .hero_desc {\n        width: 100%;\n        font-size: 15px;\n    }\n\n    .hero_left {\n        max-width: 100%;\n        margin-top: 10px;\n    }\n\n    .stat_item h3 {\n        font-size: 22px;\n    }\n\n    .traders_section_wrapper {\n        padding: 30px 0;\n    }\n\n    .rt_tab {\n        font-size: 18px;\n    }\n\n    .new_traders_section {\n        margin-bottom: 30px;\n    }\n\n    .prev_btn {\n        width: 24px;\n        height: 24px;\n        font-size: 17px;\n    }\n\n    .next_btn {\n        width: 24px;\n        height: 24px;\n        font-size: 17px;\n    }\n\n    .rt_roi .green_text {\n        font-size: 16px;\n    }\n\n    .rt_user_info h4 {\n        font-size: 15px;\n    }\n\n    .rt_card .copy_btn {\n        padding: 6px 18px;\n        font-size: 12px;\n    }\n\n    .rt_card {\n        padding: 15px;\n    }\n\n    .prudent_trader_section {\n        margin-top: 10px;\n        padding-top: 30px;\n    }\n\n    .profit_title {\n        font-size: 28px;\n        margin-bottom: 20px;\n    }\n\n    .btn_apply {\n        padding: 10px 24px;\n        font-size: 14px;\n    }\n\n    .btn_go {\n        font-size: 14px;\n    }\n\n    .total_profit_section {\n        margin-top: 40px;\n        padding: 40px 0;\n    }\n\n\n}\n\n@media (max-width:767px) {\n\n    .copy_settings_wrapper.copy_detailpage .copy_settings_layout {\n        flex-direction: column;\n    }\n\n    .breadcrumbs {\n        font-size: 12px;\n    }\n\n    .form_label {\n        font-size: 13px;\n    }\n\n    .note_box {\n        padding: 12px;\n        font-size: 13px;\n    }\n\n    .checkbox_rule label {\n        font-size: 12px;\n    }\n\n    .btn_submit_copy {\n        padding: 10px;\n        font-size: 13px;\n    }\n\n    .filter_modal_overlay {\n        align-items: end;\n    }\n\n    .filter_modal_content {\n        border-radius: 16px 16px 0px 0px;\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .copy_settings_left {\n        gap: 22px;\n    }\n\n    .copy_settings_wrapper.copy_detailpage .copy_settings_left .more_settings_header {\n        padding: 2px 0;\n    }\n\n    .stc_stats_grid {\n        gap: 15px;\n        padding-bottom: 12px;\n        margin-bottom: 10px;\n    }\n\n    .copy_settings_wrapper.copy_detailpage .copy_settings_right {\n        width: 100%;\n    }\n\n    .stc_link_item {\n        font-size: 13px;\n    }\n\n    .input_box_wrapper input {\n        font-size: 12px;\n    }\n\n    .input_suffix {\n        font-size: 12px;\n    }\n\n    .custom_select_value {\n        font-size: 13px;\n    }\n\n    .copy_settings_title {\n        font-size: 20px;\n        margin: 16px 0px 20px;\n    }\n\n    .rt_card {\n        min-height: 90px;\n    }\n\n}\n\n@media (max-width: 666px) {\n\n    .tabs_right .help_btn {\n        font-size: 12px;\n        gap: 6px;\n    }\n\n    .tabs_left {\n        gap: 10px;\n    }\n\n    .tab_btn {\n        font-size: 12px;\n        padding: 5px 10px;\n    }\n\n    .copy_trading_page_wrapper .hero_title {\n        font-size: 22px;\n    }\n\n    .hero_desc {\n        font-size: 14px;\n    }\n\n    .stat_item h3 {\n        font-size: 18px;\n    }\n\n    .copy_trading_hero {\n        gap: 20px;\n    }\n\n    .slide_title {\n        max-width: 100%;\n        font-size: 18px;\n        margin: 14px 0px;\n    }\n\n    .slider_image img {\n        max-width: 100px;\n    }\n\n    .slide_tag {\n        font-size: 14px;\n        margin-bottom: 10px;\n    }\n\n    .hero_slider_card {\n        padding: 10px 20px;\n        min-height: 190px;\n    }\n\n    .copy_trading_page_wrapper {\n        padding: 15px 0 30px 0;\n        min-height: 100%;\n    }\n\n    .section_header {\n        flex-direction: column;\n        gap: 15px;\n        align-items: start;\n        margin-bottom: 20px;\n    }\n\n    .section_header h2 {\n        font-size: 20px;\n    }\n\n    .recommend_tabs {\n        gap: 14px;\n        margin-bottom: 18px;\n    }\n\n    .rt_tab {\n        font-size: 15px;\n        padding: 5px 0px;\n    }\n\n    .traders_grid {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 18px;\n    }\n\n    .tgc_pnl h3 {\n        font-size: 20px;\n    }\n\n    .rising_talents_section {\n        padding-top: 20px;\n    }\n\n    .rt_header_left h2 {\n        font-size: 20px;\n    }\n\n    .rt_header_left p {\n        font-size: 13px;\n    }\n\n    .more_btn {\n        padding: 5px 12px;\n        font-size: 13px;\n    }\n\n    .rising_talents_list {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 18px;\n    }\n\n    .prudent_trader_section {\n        padding-top: 20px;\n        margin-bottom: 24px !important;\n    }\n\n\n    .prudent_trader_list {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 18px;\n    }\n\n    .rt_avatar {\n        width: 32px;\n        height: 32px;\n    }\n\n    .medal_icon {\n        display: none;\n    }\n\n    .profit_subtitle {\n        font-size: 15px;\n    }\n\n    .profit_title {\n        font-size: 24px;\n    }\n\n    .btn_apply {\n        padding: 8px 24px;\n        font-size: 13px;\n    }\n\n    .profit_actions {\n        padding: 7px;\n    }\n\n    .tgc_name_info h4 {\n        flex-wrap: wrap;\n    }\n\n    .pagination_wrapper {\n        display: flex;\n        justify-content: center;\n        gap: 4px;\n        flex-wrap: nowrap;\n        margin-top: 24px;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        padding: 4px 10px;\n        box-sizing: border-box;\n        scrollbar-width: none;\n        /* Hide scrollbar Firefox */\n    }\n\n    .pagination_wrapper::-webkit-scrollbar {\n        display: none;\n        /* Hide scrollbar Chrome/Safari */\n    }\n\n    .page_btn {\n        width: 28px;\n        height: 28px;\n        font-size: 12px;\n        flex-shrink: 0;\n    }\n\n    .page_dots {\n        padding: 0;\n        margin: 0 2px;\n        flex-shrink: 0;\n    }\n\n    .cfd_filter_bar {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n    }\n\n    .cfd_filter_left {\n        overflow-x: auto;\n        white-space: nowrap;\n        padding-bottom: 4px;\n        -webkit-overflow-scrolling: touch;\n        scrollbar-width: none;\n    }\n\n    .cfd_filter_left::-webkit-scrollbar {\n        display: none;\n    }\n\n    .cfd_filter_right {\n        justify-content: space-between;\n        gap: 8px;\n    }\n\n    .copy_search_wrapper {\n        flex-grow: 1;\n        width: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
